import classNames from 'classnames';
import type { PropsWithChildren } from 'react';
import React, { use } from 'react';

import 'src/styling/global.scss';

import { ExternalLink } from 'src/components/common/website-link';
import Footer from 'src/components/layout/footer';
import SimpleNavBarWithSpacer from 'src/components/layout/simple-nav-bar-with-spacer';
import GlobalContentProvider from 'src/content/global-content-provider';
import { SiteContext } from 'src/context/site-context';
import { navigateToExternalPage } from 'src/helpers/navigation-helper';

import * as styles from './simple-page-layout.module.scss';
import Snippets from './snippets';

type SimplePageLayoutProps = PropsWithChildren<{
  shouldShowFooter: boolean;
  globalCmsPageData: unknown;
}>;

export const SimplePageLayout: React.FC<SimplePageLayoutProps> = ({
  shouldShowFooter,
  globalCmsPageData,
  children,
}) => {
  const { buildType } = use(SiteContext);
  return (
    <GlobalContentProvider globalCmsPageData={globalCmsPageData}>
      <div className={classNames(styles.wrapper, !shouldShowFooter && styles.noFooter)}>
        <SimpleNavBarWithSpacer
          onCloseButtonClicked={() => navigateToExternalPage('/')}
          logoWrapper={<ExternalLink to={'/'} />}
        />
        <div className={styles.content}>{children}</div>
      </div>
      {shouldShowFooter && <Footer />}
      <Snippets buildType={buildType} />
    </GlobalContentProvider>
  );
};
